import React from 'react';
import { graphql } from 'gatsby';

import { useFelaEnhanced } from '@ackee/fela';
import { LocalizedLink } from '../../../ui';
import type { PostTag } from '../../types';

import * as felaRules from './TagsList.rules';

export interface TagsListProps {
    tags: PostTag[];
}

export const TagsList = ({ tags }: TagsListProps) => {
    const { styles } = useFelaEnhanced(felaRules);

    return (
        <ul className={styles.container}>
            {tags.map(tag => (
                <li key={tag.slug}>
                    <LocalizedLink to={`/blog/tag/${tag.slug}`} className={styles.link}>
                        {tag.title}
                    </LocalizedLink>
                </li>
            ))}
        </ul>
    );
};

export const query = graphql`
    fragment PostTag on STRAPI_TAG {
        slug
        title
    }
`;
